const CurrencyEnum = {
    groups0_m1_RUB: 'groups0_m1_RUB',
    groups0_m1_USD: 'groups0_m1_USD',
    groups0_m1_EUR: 'groups0_m1_EUR',
    groups0_1_RUB: 'groups0_1_RUB',
    groups0_1_USD: 'groups0_1_USD',
    groups0_1_EUR: 'groups0_1_EUR',
    groups0_2_RUB: 'groups0_2_RUB',
    groups0_2_USD: 'groups0_2_USD',
    groups0_2_EUR: 'groups0_2_EUR',

    groups1_m1: 'groups1_m1',
    groups1_1: 'groups1_1',
    groups1_2: 'groups1_2',
    groups2_m1: 'groups2_m1',
    groups2_1: 'groups2_1',
    groups2_2: 'groups2_2',
    groups3_m1: 'groups3_m1',
    groups3_1: 'groups3_1',
    groups3_2: 'groups3_2',
    groups4_m1: 'groups4_m1',
    groups4_1: 'groups4_1',
    groups4_2: 'groups4_2',

    groups9_m1_RUB: 'groups9_m1_RUB',
    groups9_m1_USD: 'groups9_m1_USD',
    groups9_m1_EUR: 'groups9_m1_EUR',
    groups9_1_RUB: 'groups9_1_RUB',
    groups9_1_USD: 'groups9_1_USD',
    groups9_1_EUR: 'groups9_1_EUR',
    groups9_2_RUB: 'groups9_2_RUB',
    groups9_2_USD: 'groups9_2_USD',
    groups9_2_EUR: 'groups9_2_EUR',

    names_1: 'names_1',
    names_1_1: 'names_1_1',
    names_1_2: 'names_1_2',
    names_1_3: 'names_1_3',
    names_1_4: 'names_1_4',
    names_2: 'names_2',
    names_2_1: 'names_2_1',
    names_2_2: 'names_2_2',
    names_2_3: 'names_2_3',
    names_2_4: 'names_2_4',
    names_3: 'names_3',
    names_4: 'names_4',
    names_5: 'names_5',
    names_6: 'names_6',
    names_7: 'names_7',
    names_8: 'names_8',
    names_9: 'names_9',
    names_10: 'names_10',
    names_11: 'names_11',
    names_12: 'names_12',
    names_13: 'names_13',
    names_14: 'names_14',
    names_15: 'names_15',
    names_16: 'names_16',
    names_17: 'names_17',
    names_18: 'names_18',
    names_19: 'names_19',
    names_20: 'names_20',
    names_30: 'names_30',
    names_40: 'names_40',
    names_50: 'names_50',
    names_60: 'names_60',
    names_70: 'names_70',
    names_80: 'names_80',
    names_90: 'names_90',
    names_100: 'names_100',
    names_200: 'names_200',
    names_300: 'names_300',
    names_400: 'names_400',
    names_500: 'names_500',
    names_600: 'names_600',
    names_700: 'names_700',
    names_800: 'names_800',
    names_900: 'names_900',
    zero: 'zero'
};

const StringResources = {
    groups0_m1_RUB: ' рублей', groups0_m1_USD: ' долларов США', groups0_m1_EUR: ' евро',
    groups0_1_RUB: ' рубль', groups0_1_USD: ' доллар США', groups0_1_EUR: ' евро',
    groups0_2_RUB: ' рубля', groups0_2_USD: ' доллара США', groups0_2_EUR: ' евро',

    groups1_m1: 'тысяч', groups1_1: 'тысяча', groups1_2: 'тысячи',
    groups2_m1: 'миллионов', groups2_1: 'миллион', groups2_2: 'миллиона',
    groups3_m1: 'миллиардов', groups3_1: 'миллиард', groups3_2: 'миллиарда',
    groups4_m1: 'триллионов', groups4_1: 'триллион', groups4_2: 'триллиона',

    groups9_m1_RUB: 'копеек', groups9_m1_USD: 'центов', groups9_m1_EUR: 'центов',
    groups9_1_RUB: 'копейка', groups9_1_USD: 'цент', groups9_1_EUR: 'цент',
    groups9_2_RUB: 'копейки', groups9_2_USD: 'цента', groups9_2_EUR: 'цента',

    names_1: 'один', names_1_1: 'одна', names_1_2: 'один', names_1_3: 'один', names_1_4: 'один',
    names_2: 'два', names_2_1: 'две', names_2_2: 'два', names_2_3: 'два', names_2_4: 'два',
    names_3: 'три', names_4: 'четыре', names_5: 'пять',
    names_6: 'шесть', names_7: 'семь', names_8: 'восемь', names_9: 'девять', names_10: 'десять',
    names_11: 'одиннадцать', names_12: 'двенадцать', names_13: 'тринадцать', names_14: 'четырнадцать',
    names_15: 'пятнадцать', names_16: 'шестнадцать', names_17: 'семнадцать', names_18: 'восемнадцать',
    names_19: 'девятнадцать', names_20: 'двадцать', names_30: 'тридцать', names_40: 'сорок',
    names_50: 'пятьдесят', names_60: 'шестьдесят', names_70: 'семьдесят', names_80: 'восемьдесят',
    names_90: 'девяносто', names_100: 'сто', names_200: 'двести', names_300: 'триста',
    names_400: 'четыреста', names_500: 'пятьсот', names_600: 'шестьсот', names_700: 'семьсот',
    names_800: 'восемьсот', names_900: 'девятьсот',
    zero: 'ноль'
};

const StringResourcesEn = {
    groups0_m1_RUB: ' rubles', groups0_m1_USD: ' US dollars', groups0_m1_EUR: ' euros',
    groups0_1_RUB: ' ruble', groups0_1_USD: ' US dollar', groups0_1_EUR: ' euro',
    groups0_2_RUB: ' rubles', groups0_2_USD: ' US dollars', groups0_2_EUR: ' euros',

    groups1_m1: 'thousands', groups1_1: 'thousand', groups1_2: 'thousands',
    groups2_m1: 'millions', groups2_1: 'million', groups2_2: 'millions',
    groups3_m1: 'billions', groups3_1: 'billion', groups3_2: 'billions',
    groups4_m1: 'trillions', groups4_1: 'trillion', groups4_2: 'trillions',

    groups9_m1_RUB: 'kopecks', groups9_m1_USD: 'cents', groups9_m1_EUR: 'cents',
    groups9_1_RUB: 'kopeck', groups9_1_USD: 'cent', groups9_1_EUR: 'cent',
    groups9_2_RUB: 'kopecks', groups9_2_USD: 'cents', groups9_2_EUR: 'cents',

    names_1: 'one', names_1_1: 'one', names_1_2: 'one', names_1_3: 'one', names_1_4: 'one',
    names_2: 'two', names_2_1: 'two', names_2_2: 'two', names_2_3: 'two', names_2_4: 'two',
    names_3: 'three', names_4: 'four', names_5: 'five',
    names_6: 'six', names_7: 'seven', names_8: 'eight', names_9: 'nine', names_10: 'ten',
    names_11: 'eleven', names_12: 'twelve', names_13: 'thirteen', names_14: 'fourteen',
    names_15: 'fifteen', names_16: 'sixteen', names_17: 'seventeen', names_18: 'eighteen',
    names_19: 'nineteen', names_20: 'twenty', names_30: 'thirty', names_40: 'forty',
    names_50: 'fifty', names_60: 'sixty', names_70: 'seventy', names_80: 'eighty',
    names_90: 'ninety', names_100: 'one hundred', names_200: 'two hundred',
    names_300: 'three hundred', names_400: 'four hundred', names_500: 'five hundred',
    names_600: 'six hundred', names_700: 'seven hundred', names_800: 'eight hundred',
    names_900: 'nine hundred',
    zero: 'zero'
};

export function spellNumber(num, cur = 'RUB', language = "ru") {
    if (!Number.isInteger(Number.parseInt(num))) return "";

    let x = parseFloat(num);
    if (x < 0 || x > 999999999999999.99) return "";

    let currency = typeof cur === 'string' ? cur.trim().toUpperCase() : 'RUB';
    if (currency === 'RUR') currency = 'RUB';
    if (!['RUB', 'USD', 'EUR'].includes(currency)) return "";

    const getStringValue = (enumKey) => {
        let resource = language === 'ru' ? StringResources : StringResourcesEn;
        return resource[enumKey] || '';
    }

    const getFormIndex = (n) => {
        n = Math.abs(n) % 100;
        if (n >= 11 && n <= 19) return -1;
        const last = n % 10;
        if (last === 1) return 1;
        if (last >= 2 && last <= 4) return 2;
        return -1;
    }

    var groups = [];
    groups[0] = [];
    groups[1] = [];
    groups[2] = [];
    groups[3] = [];
    groups[4] = [];
    groups[9] = [];

    groups[0][-1] = {
        'RUB': getStringValue(CurrencyEnum.groups0_m1_RUB),
        'USD': getStringValue(CurrencyEnum.groups0_m1_USD),
        'EUR': getStringValue(CurrencyEnum.groups0_m1_EUR)
    };
    groups[0][1] = {
        'RUB': getStringValue(CurrencyEnum.groups0_1_RUB),
        'USD': getStringValue(CurrencyEnum.groups0_1_USD),
        'EUR': getStringValue(CurrencyEnum.groups0_1_EUR)
    };
    groups[0][2] = {
        'RUB': getStringValue(CurrencyEnum.groups0_2_RUB),
        'USD': getStringValue(CurrencyEnum.groups0_2_USD),
        'EUR': getStringValue(CurrencyEnum.groups0_2_EUR)
    };

    groups[1][-1] = getStringValue(CurrencyEnum.groups1_m1);
    groups[1][1] = getStringValue(CurrencyEnum.groups1_1);
    groups[1][2] = getStringValue(CurrencyEnum.groups1_2);
    groups[2][-1] = getStringValue(CurrencyEnum.groups2_m1);
    groups[2][1] = getStringValue(CurrencyEnum.groups2_1);
    groups[2][2] = getStringValue(CurrencyEnum.groups2_2);
    groups[3][-1] = getStringValue(CurrencyEnum.groups3_m1);
    groups[3][1] = getStringValue(CurrencyEnum.groups3_1);
    groups[3][2] = getStringValue(CurrencyEnum.groups3_2);
    groups[4][-1] = getStringValue(CurrencyEnum.groups4_m1);
    groups[4][1] = getStringValue(CurrencyEnum.groups4_1);
    groups[4][2] = getStringValue(CurrencyEnum.groups4_2);

    groups[9][-1] = {
        'RUB': getStringValue(CurrencyEnum.groups9_m1_RUB),
        'USD': getStringValue(CurrencyEnum.groups9_m1_USD),
        'EUR': getStringValue(CurrencyEnum.groups9_m1_EUR)
    };
    groups[9][1] = {
        'RUB': getStringValue(CurrencyEnum.groups9_1_RUB),
        'USD': getStringValue(CurrencyEnum.groups9_1_USD),
        'EUR': getStringValue(CurrencyEnum.groups9_1_EUR)
    };
    groups[9][2] = {
        'RUB': getStringValue(CurrencyEnum.groups9_2_RUB),
        'USD': getStringValue(CurrencyEnum.groups9_2_USD),
        'EUR': getStringValue(CurrencyEnum.groups9_2_EUR)
    };

    var names = [];
    names[1] = {
        0: getStringValue(CurrencyEnum.names_1),
        1: getStringValue(CurrencyEnum.names_1_1),
        2: getStringValue(CurrencyEnum.names_1_2),
        3: getStringValue(CurrencyEnum.names_1_3),
        4: getStringValue(CurrencyEnum.names_1_4)
    };
    names[2] = {
        0: getStringValue(CurrencyEnum.names_2),
        1: getStringValue(CurrencyEnum.names_2_1),
        2: getStringValue(CurrencyEnum.names_2_2),
        3: getStringValue(CurrencyEnum.names_2_3),
        4: getStringValue(CurrencyEnum.names_2_4)
    };
    [3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
        20, 30, 40, 50, 60, 70, 80, 90, 100, 200, 300, 400, 500, 600, 700, 800, 900]
        .forEach(n => names[n] = getStringValue(CurrencyEnum[`names_${n}`]));

    var r = '';
    var units = "";
    var i, j;
    var y = Math.floor(x);

    if (y > 0) {
        var t = [];
        for (i = 0; i <= 4; i++) {
            t[i] = y % 1000;
            y = Math.floor(y / 1000);
        }

        var d = [];
        for (i = 0; i <= 4; i++) {
            d[i] = [];
            d[i][0] = t[i] % 10;
            d[i][10] = t[i] % 100 - d[i][0];
            d[i][100] = t[i] - d[i][10] - d[i][0];
            d[i][11] = t[i] % 100;
        }

        for (i = 4; i >= 0; i--) {
            if (t[i] > 0) {
                if (names[d[i][100]])
                    r += ' ' + ((typeof names[d[i][100]] === 'object') ? (names[d[i][100]][i]) : names[d[i][100]]);
                if (names[d[i][11]])
                    r += ' ' + ((typeof names[d[i][11]] === 'object') ? (names[d[i][11]][i]) : names[d[i][11]]);
                else {
                    if (names[d[i][10]]) r += ' ' + ((typeof names[d[i][10]] === 'object') ? (names[d[i][10]][i]) : names[d[i][10]]);
                    if (names[d[i][0]]) r += ' ' + ((typeof names[d[i][0]] === 'object') ? (names[d[i][0]][i]) : names[d[i][0]]);
                }

                j = getFormIndex(t[i]);
                if (groups[i][j]) {
                    if (i === 0) {
                        if (language === "en" && x > 1) {
                            units = groups[i][-1][currency];
                        } else {
                            units = groups[i][j][currency];
                        }
                        r += units;
                    } else r += ' ' + groups[i][j];
                } else {
                    if (i === 0) {
                        units = groups[i][-1][currency];
                        r += units;
                    } else r += ' ' + groups[i][-1];
                }
            }
        }

        if (t[0] === 0) {
            units = groups[0][-1][currency];
            r += units;
        }
    } else {
        units = groups[0][-1][currency];
        r = getStringValue(CurrencyEnum.zero) + units;
    }

    y = Math.round((x - Math.floor(x)) * 100);
    if (y < 10) y = '0' + y;

    r = r.split(/\s+/).join(' ').trim();

    if (num.includes(".")) {
        r += ' ' + y;
        y *= 1;
        j = getFormIndex(y);
        if (groups[9][j]) r += ' ' + groups[9][j][currency];
        else r += ' ' + groups[9][-1][currency];
    }

    num = num.replace(',', '.');
    num = new Intl.NumberFormat('ru-RU').format(num);
    r = num + units + " (" + r + ")";

    return r;
}

